/*
 *
 *  session remotes
 *
 */

import api from "../../helpers/index"

export function verifySession() {
  return api
    .get(`/get_session_user_info`)
    .then((response) => response.data && response.data.data)
    .catch((error) => Promise.reject(error))
}

/**
 * @param {string} email
 * @param {string} password
 * @param {object} queryParams
 * @param {boolean} sessionLogin
 */
export function logIn(user) {
  return api
    .post(`/login`, user)
    .then((response) => response.data && response.data.data)
    .catch((error) => Promise.reject(error))
}

export function logOut() {
  const payload = { oneSignalDeviceId: "5829636e-5535-4bdc-a77c-fce7f3a19022" }

  console.log(payload, "payload")

  return api
    .delete(`/session`, payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

/**
 * @param {object} record
 */
export async function forgotPassword(record) {
  return await api
    .post(`/forget-paasword`, record)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//reset
export async function resetPasswordAPI(reset_Password) {
  console.log(reset_Password, "inside remote")
  return await api
    .post(`/change_password`, reset_Password)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

//reset
export async function otpApproveAPI(otp_approve) {
  console.log(otp_approve, "inside remote")
  return await api
    .post(`/otp_verify`, otp_approve)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error))
}

const remotes = {
  verifySession,
  logIn,
  logOut,
  forgotPassword,
  resetPasswordAPI,
  otpApproveAPI,
}

export default remotes
